import { ReactNode, useState } from "react";
import { Button, Card, Popover } from "@introist/react-foundation/v2";
import styled from "styled-components";

const Content = styled(Card)`
  width: 380px;
  max-height: 320px;
  overflow-y: auto;
  padding: var(--spacing-medium);
  box-sizing: border-box;
`;

export const ParametersHelp = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [ref, setRef] = useState<HTMLElement | null>(null);

  return (
    <div ref={setRef} style={{ display: "inline-flex" }}>
      <Button
        variant="blended"
        size="small"
        startIcon="infoFilled"
        onClick={() => setOpen(o => !o)}
      >
        Help
      </Button>
      <Popover
        open={open}
        referenceElement={ref}
        onClose={() => setOpen(false)}
        placement="bottom-start"
        closeOnContentClick={false}
      >
        <Content>{children}</Content>
      </Popover>
    </div>
  );
};
